import type { HubBuyingFavorite } from 'components/hub/useHubBuyerListingsAndTours';
import type { HubBuyingOffer } from 'components/hub/useHubPurchaseOffers';
import type { HubSellingTransaction } from 'components/hub/useHubSellerTransactions';

import { isActiveSaleTransaction, isPastSaleTransaction } from './saleTransactionCardModel';

export const hasActiveSaleTransactions = (transactions: HubSellingTransaction[]): boolean =>
  transactions.some((transaction) => isActiveSaleTransaction(transaction));

export const hasRenderableSaleTransactions = (transactions: HubSellingTransaction[]): boolean =>
  transactions.some(
    (transaction) => isActiveSaleTransaction(transaction) || isPastSaleTransaction(transaction),
  );

export const isHomeSaleSectionVisible = (
  transactions: HubSellingTransaction[],
  isLoading: boolean,
): boolean => isLoading || hasRenderableSaleTransactions(transactions);

export const hasRenderablePurchaseOffers = (offers: HubBuyingOffer[]): boolean => offers.length > 0;

export const isHomePurchaseSectionVisible = (
  offers: HubBuyingOffer[],
  isLoading: boolean,
): boolean => isLoading || hasRenderablePurchaseOffers(offers);

export const isSavedHomesSectionVisible = (
  favorites: HubBuyingFavorite[],
  isLoading: boolean,
): boolean => isLoading || favorites.length > 0;

// The cash-offer recommendation is a prompt to start a new sale, so it must
// stay hidden until we know the customer has no active sale — while loading,
// when seller data is unavailable, or when an active sale is present —
// to avoid a flash or a stuck card for active-sale customers.
export const isRecommendationsSectionVisible = (
  transactions: HubSellingTransaction[],
  isLoading: boolean,
  hasSellerDataError: boolean,
): boolean => !isLoading && !hasSellerDataError && !hasActiveSaleTransactions(transactions);
